import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import { http } from './service/http'

// UI element ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 重置样式
import '@/style/reset.css'
// 全局样式
import './style/commonStyle.less'

// 关闭生产模式下给出的提示
Vue.config.productionTip = false

Vue.prototype.$Api = http
Vue.use(ElementUI)

require('./icons/index')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
